<template>
	<form class="w-100" onsubmit="return false;">
		<v-row v-show="HasError"><v-col class="py-1">
            <error></error>
		</v-col></v-row>
		<v-row><v-col class="py-1">
			<c-input
				v-model="email"
				labelWidth="10%"
				:title="$t('text.email')"
				:error="emailErrors"
				:disabled="loading"
				@blur="validateEmail"
				@keyup.enter.native="login">
			</c-input>
		</v-col></v-row>
		<v-row><v-col class="py-1">
			<c-input
				v-model="password"
				labelWidth="10%"
				type="password"
				:title="$t('text.password')"
				:disabled="loading"
				@keyup.enter.native="login">
			</c-input>
		</v-col></v-row>
		<v-row><v-col class="py-1"
			cols="12" sm="4">
			<c-button
				:disabled="loading"
				@click="login"
				type="important"
				:label="$t(`text.loginButton`)"
				class="mr-2 w-100">
			</c-button>
		</v-col>
		<v-col class="py-1"
			cols="12" sm="4">
			<c-button
				:disabled="loading"
				@click="forgotPassword"
				:label="$t(`text.forgotPasswordButton`)"
				class="mr-2 w-100">
			</c-button>
		</v-col>
		<v-col class="py-1"
			cols="12" sm="4">
			<c-button
				:disabled="loading"
				@click="register"
				:label="$t(`text.registerButton`)"
				class="w-100">
			</c-button>
		</v-col></v-row>
		<spinner :loading="loading"></spinner>
      </form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import authActions from '../store/actions/auth';
import rootActions from '../store/actions/root';
import errorActions from '../store/actions/error';
import namespace from '../store/namespace';

import Spinner from '../general/Spinner.vue';

import CInput from '../globalComponents/CInput.vue';
import CButton from '../globalComponents/CButton.vue';
import Error from '../general/Error.vue';

import modelState from '../mixins/modelState';

import rules from '../globalComponents/mixins/rules';

export default {
	name: 'Login',
	mixins: [modelState, rules],
	components: {
		CButton,
		CInput,
		Spinner,
		Error,
	},
	data() {
		return {
			email: '',
			emailErrors: {},
			modelState: {},
			password: '',
			loading: false,
			valid: true,
		};
	},
	computed: {
		...mapGetters(namespace.ERROR, ['HasError', 'Message']),
		passwordErrors() {
			const errors = [];

			if (!this.$v.password.$dirty) return errors;

			const apiErrors = this.validateProperty('Password');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			!this.$v.password.required
        && errors.push(this.$i18n.t('text.errorPasswordRequired'));

			return errors;
		},
	},
	mounted() {
		this.LOGOUT();
		this.REMOVE_AUTH_FLAG();
		this.REMOVE_ERROR();
	},
	methods: {
		...mapActions(namespace.AUTH, [authActions.LOGIN, authActions.LOGOUT]),
		...mapActions([rootActions.GET_ROOT_LINKS_AUTH]),
		...mapMutations([rootActions.REMOVE_AUTH_FLAG]),
		...mapMutations(namespace.AUTH, [authActions.LOGIN_FINISHED]),
		...mapActions(namespace.ERROR, [errorActions.REMOVE_ERROR]),
		validateEmail() {
			this.emailErrors = {};
			if (this.isEmpty(this.email)) this.emailErrors = { show: true, message: this.$i18n.t('text.errorEmailRequired') };
			else if (this.isInvalidEmail(this.email)) this.emailErrors = { show: true, message: this.$i18n.t('text.errorInvalidEmail') };
			else this.emailErrors = this.apiErrors('Email');
		},
		apiErrors(propName) {
			const apiErrors = this.validateProperty(propName);

			if (apiErrors.length > 0) return { show: true, message: apiErrors };

			return {};
		},
		async login() {
			this.loading = true;

			if (this.valid) {
				try {
					this.modelState = {};
					await this.LOGIN(this);
					await this.GET_ROOT_LINKS_AUTH();
					this.LOGIN_FINISHED();

					if (this.$route.query && this.$route.query.redirect) {
						this.$router.push(this.$route.query.redirect);
					} else if (this.$route.name !== 'dashboard') this.$router.push('/dashboard');
				} catch (e) {
					throw e;
				} finally {
					this.loading = false;
				}
			}
			this.loading = false;
		},
		forgotPassword() {
			this.$router.push({
				name: 'forgotpassword',
				params: { cGuid: this.cGuid },
			});
		},
		register() {
			this.$router.push({
				name: 'register',
				params: { cGuid: this.cGuid },
			});
		},
	},
};
</script>

<style lang="scss" scoped>

@import "../globalComponents/style/_globals";


</style>
